import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './Title.module.css';

export interface TitleProps {
    title: string;
    className?: string;
}

export const Title: FunctionComponent<TitleProps> = props => {
    return <span className={clsx(styles.text, props.className)}>{props.title}</span>;
};

export default TitleProps;
